/**
 * Per-document verification status for the six prose documents (inc6 step E,
 * approved gate class: available-with-warning — never blocks, always honest).
 * Derived from the latest pipeline run's M-checks. The server export
 * handlers embed the same derivation (functions/src/index.ts,
 * proseDocVerificationForExport) — keep the two in step.
 */

export interface RunCheckItemsLike {
  checkId: string;
  items?: Array<{ kind?: string; data?: Record<string, string> }>;
}

export type ProseDocStatusValue = 'clean' | 'issues' | 'unverified' | 'unknown';

export function proseDocStatus(
  checks: RunCheckItemsLike[] | null | undefined,
  docKey: string,
): { status: ProseDocStatusValue; count: number } {
  if (!checks) return { status: 'unknown', count: 0 };
  let issues = 0;
  let unverified = false;
  for (const c of checks) {
    for (const item of c.items ?? []) {
      if (item.data?.doc !== docKey) continue;
      if (c.checkId === 'M1' || c.checkId === 'M3') issues++;
      else if (c.checkId === 'M2') unverified = true;
    }
  }
  if (issues > 0) return { status: 'issues', count: issues };
  if (unverified) return { status: 'unverified', count: 0 };
  return { status: 'clean', count: 0 };
}
